<template>
  <div class="center">
    <!-- 返回键 -->
    <div class="back" @click="back()">
      <i></i>
      <span>返回</span>
    </div>
    <!-- 主体部分 -->
    <div class="mian_view">
      <p class="inform">消息通知</p>
      <div class="title">
        <h2>{{row.NoticeName}}</h2>
      </div>
      <div class="textbox">
        <div class="box_mian">
          <div class="text_view">{{row.NoticeContent}}</div>
          <div class="data_view">
            <p>{{UpdateTime}}</p>
            <p>管理员:{{row.Publisher}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userCheckNotice } from "@/api/examination.js";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
        row:{},
        UpdateTime:''
    };
  },
  props: ["cutcoms"],
  methods: {
    back() {
      this.cutcoms(0);
      this.$destroy();
    },
   async getAnnouncement() {
      let params = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        NoticeID: this.$parent.currentLine.NoticeID,
        checkType: 0, // 传0是查看，传1是忽略
        hid: JSON.parse(loginvuex.state.hid),
      };
      const {data} = await userCheckNotice(params)
      if(data.Status == 200){
           this.row = data.Data
           this.UpdateTime = this.$moment(this.row.UpdateTime).format(
          "YYYY年MM月DD日 HH:mm"
        );
      }
      console.log(this.row,'请求参数');
    },
  },
  created() {
    this.getAnnouncement();
  },
};
</script>

<style lang="scss" scoped>
.back {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  //   border-radius: 0px 0px 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    //  background-color: aqua;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.center {
  min-height: 800px;
  width: 100%;
  // padding: 24px !important;
  //   min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
.mian_view {
  padding: 24px;
  .inform {
    margin-bottom: 24px;
    font-weight: bold;
    border-bottom: 4px solid #1890ff;
  }
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 22px;
  }
  .box_mian {
    position: relative;
  }
  .textbox {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .text_view {
      padding: 12px;
      border: 1px solid #ccc;
      border-radius: 5px;
      width: 752px;
      height: 302px;
      overflow-y: scroll;
      word-wrap: break-word;

      word-break: normal;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .data_view {
      position: absolute;

      right: 0;
      bottom: -80px;
      p {
        margin-bottom: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>